import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import type { LanguageName } from '../../types';

type NameProps = {
  name: LanguageName;
};

const fontSizeMapping = {
  small: 13,
  medium: 14,
  large: 16
};

const lineHeightMapping = {
  small: 16,
  medium: 18,
  large: 22
};

export function Name({ name }: NameProps) {
  const { widgetSize } = useSettings();

  return (
    <NameContainer
      _fontSize={fontSizeMapping[widgetSize]}
      _lineHeight={lineHeightMapping[widgetSize]}
    >
      {name}
    </NameContainer>
  );
}

export const NameContainer = styled.div<{
  _fontSize: number;
  _lineHeight: number;
}>`
  font-size: ${({ _fontSize }) => _fontSize}px;
  line-height: ${({ _lineHeight }) => _lineHeight}px;
`;
